import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, TransitionGroup as _TransitionGroup, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white overflow-hidden" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" }
const _hoisted_4 = { class: "order-2 lg:order-1" }
const _hoisted_5 = { class: "flex items-center gap-1 bg-neutral-100 rounded-xl p-1 w-fit mb-6" }
const _hoisted_6 = { class: "flex flex-col sm:flex-row gap-3 mb-8" }
const _hoisted_7 = { class: "relative flex-1" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = { class: "flex -space-x-2" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "flex items-center gap-1.5" }
const _hoisted_13 = { class: "flex text-yellow-400 text-sm" }
const _hoisted_14 = { class: "text-sm font-semibold text-neutral-700" }
const _hoisted_15 = {
  key: 0,
  class: "inline-block w-8 h-3.5 bg-neutral-200 animate-pulse rounded"
}
const _hoisted_16 = { class: "text-sm text-neutral-400" }
const _hoisted_17 = {
  key: 0,
  class: "inline-block w-8 h-3 bg-neutral-200 animate-pulse rounded"
}
const _hoisted_18 = { class: "order-1 lg:order-2 relative select-none" }
const _hoisted_19 = { class: "relative rounded-3xl overflow-hidden shadow-2xl h-[420px] md:h-[500px] lg:h-[540px]" }
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "absolute top-5 right-5" }
const _hoisted_22 = { class: "bg-primary-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg" }
const _hoisted_23 = { class: "absolute top-5 left-5 bg-black/40 backdrop-blur-sm text-white text-xs font-semibold px-3 py-1.5 rounded-full" }
const _hoisted_24 = { class: "absolute bottom-0 left-0 right-0 p-5" }
const _hoisted_25 = { class: "bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-4" }
const _hoisted_26 = { class: "flex items-start justify-between gap-3 mb-3" }
const _hoisted_27 = { class: "min-w-0" }
const _hoisted_28 = { class: "text-white font-bold text-base leading-snug line-clamp-1" }
const _hoisted_29 = { class: "text-white/70 text-xs mt-1 flex items-center gap-1" }
const _hoisted_30 = { class: "flex-shrink-0 text-right" }
const _hoisted_31 = { class: "text-white font-extrabold text-base" }
const _hoisted_32 = { class: "text-white/60 text-xs" }
const _hoisted_33 = { class: "flex items-center gap-4" }
const _hoisted_34 = {
  key: 0,
  class: "flex items-center gap-1.5 text-white/80 text-xs font-medium"
}
const _hoisted_35 = { class: "flex items-center gap-1.5 text-white/80 text-xs font-medium" }
const _hoisted_36 = { class: "flex items-center gap-1.5 text-white/80 text-xs font-medium" }
const _hoisted_37 = {
  key: 0,
  class: "flex items-center gap-1.5 text-white/80 text-xs font-medium"
}
const _hoisted_38 = { class: "flex items-center justify-center gap-2 mt-4" }
const _hoisted_39 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"inline-flex items-center gap-2 bg-primary-50 text-primary-500 text-sm font-medium px-4 py-1.5 rounded-full mb-6\" data-v-298996ea><span class=\"w-2 h-2 rounded-full bg-primary-500 animate-pulse\" data-v-298996ea></span> Rwanda&#39;s #1 Property Platform </div><h2 class=\"text-2xl md:text-3xl lg:text-4xl font-bold text-neutral-800 leading-tight mb-6\" data-v-298996ea> Find Your Best <br data-v-298996ea><span class=\"text-primary-500\" data-v-298996ea>Real Estate</span> in Rwanda </h2><p class=\"text-neutral-500 text-lg mb-8 max-w-md\" data-v-298996ea> Buy, sell, or rent properties across Rwanda with confidence. Trusted by thousands of families. </p>", 3)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'buy')),
              class: _normalizeClass([_ctx.activeTab === 'buy' ? 'bg-white text-primary-500 shadow-sm' : 'text-neutral-500 hover:text-neutral-700', "px-6 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200"])
            }, " Buy House ", 2),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'sell')),
              class: _normalizeClass([_ctx.activeTab === 'sell' ? 'bg-white text-primary-500 shadow-sm' : 'text-neutral-500 hover:text-neutral-700', "px-6 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200"])
            }, " Sell House ", 2)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("svg", {
                class: "absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                }),
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSearchAction && _ctx.onSearchAction(...args)), ["enter"])),
                type: "text",
                placeholder: _ctx.activeTab === 'buy' ? 'Enter city or neighbourhood...' : 'Enter your property address...',
                class: "w-full pl-10 pr-4 py-3.5 border border-neutral-200 rounded-xl text-sm text-neutral-700 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition"
              }, null, 40, _hoisted_8), [
                [_vModelText, _ctx.searchQuery]
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSearchAction && _ctx.onSearchAction(...args))),
              class: "px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-xl transition-colors shadow-sm whitespace-nowrap"
            }, _toDisplayString(_ctx.activeTab === 'buy' ? 'Search' : 'List My Property'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.reviewsLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (i) => {
                    return _createElementVNode("div", {
                      key: i,
                      class: "w-8 h-8 rounded-full border-2 border-white bg-neutral-200 animate-pulse"
                    })
                  }), 64))
                : (_ctx.reviewAvatars.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.reviewAvatars, (av, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "w-8 h-8 rounded-full border-2 border-white flex items-center justify-center text-xs font-bold text-white flex-shrink-0",
                        style: _normalizeStyle({ background: av.gradient }),
                        title: av.name
                      }, _toDisplayString(av.initials), 13, _hoisted_11))
                    }), 128))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (s) => {
                  return _createElementVNode("span", {
                    key: s,
                    class: _normalizeClass(s <= Math.round(_ctx.avgRating) ? 'text-yellow-400' : 'text-neutral-300')
                  }, "★", 2)
                }), 64))
              ]),
              _createElementVNode("span", _hoisted_14, [
                (_ctx.reviewsLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.avgRating.toFixed(1)) + "/5", 1)
                    ], 64))
              ]),
              _createElementVNode("span", _hoisted_16, [
                _cache[8] || (_cache[8] = _createTextVNode(" — from ", -1)),
                (_ctx.reviewsLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.totalReviews.toLocaleString()) + " reviews", 1)
                    ], 64))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_TransitionGroup, {
              name: "slide-fade",
              tag: "div",
              class: "absolute inset-0"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heroProperties, (property, i) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: property.id,
                    class: "absolute inset-0"
                  }, [
                    _createElementVNode("img", {
                      src: property.image,
                      alt: property.title,
                      class: "w-full h-full object-cover"
                    }, null, 8, _hoisted_20),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" }, null, -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(property.purpose), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(i + 1) + " / " + _toDisplayString(_ctx.heroProperties.length), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("p", _hoisted_28, _toDisplayString(property.title), 1),
                            _createElementVNode("p", _hoisted_29, [
                              _cache[10] || (_cache[10] = _createElementVNode("svg", {
                                class: "w-3.5 h-3.5 flex-shrink-0",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                }),
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(property.location), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("p", _hoisted_31, "RWF " + _toDisplayString(property.price), 1),
                            _createElementVNode("p", _hoisted_32, _toDisplayString(property.pricePeriod), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          (property.propertyType === 'Plot')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex items-center gap-1.5 text-emerald-300 text-xs font-semibold" }, [
                                  _createElementVNode("svg", {
                                    class: "w-3.5 h-3.5",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                                    })
                                  ]),
                                  _createTextVNode(" Land Plot ")
                                ], -1)),
                                (property.size)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _cache[11] || (_cache[11] = _createElementVNode("svg", {
                                        class: "w-3.5 h-3.5",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                                        })
                                      ], -1)),
                                      _createTextVNode(" " + _toDisplayString(property.size) + " m² ", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_35, [
                                  _cache[13] || (_cache[13] = _createElementVNode("svg", {
                                    class: "w-3.5 h-3.5",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(property.bedrooms) + " Beds ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _cache[14] || (_cache[14] = _createElementVNode("svg", {
                                    class: "w-3.5 h-3.5",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M8 7h8m-8 5h8m-4-9v14"
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(property.bathrooms) + " Baths ", 1)
                                ]),
                                (property.size)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _cache[15] || (_cache[15] = _createElementVNode("svg", {
                                        class: "w-3.5 h-3.5",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                                        })
                                      ], -1)),
                                      _createTextVNode(" " + _toDisplayString(property.size) + " m² ", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64)),
                          _createVNode(_component_router_link, {
                            to: `/property/${property.id}`,
                            class: "ml-auto text-xs font-bold text-white bg-primary-500 hover:bg-primary-600 px-3 py-1.5 rounded-lg transition-colors flex-shrink-0"
                          }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode(" View → ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ])
                    ])
                  ])), [
                    [_vShow, _ctx.currentSlide === i]
                  ])
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args))),
              class: "absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white rounded-full flex items-center justify-center transition-colors z-10"
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2.5",
                  d: "M15 19l-7-7 7-7"
                })
              ], -1)
            ]))]),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args))),
              class: "absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white rounded-full flex items-center justify-center transition-colors z-10"
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2.5",
                  d: "M9 5l7 7-7 7"
                })
              ], -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_38, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heroProperties, (_, i) => {
              return (_openBlock(), _createElementBlock("button", {
                key: i,
                onClick: ($event: any) => (_ctx.goToSlide(i)),
                class: _normalizeClass(["transition-all duration-300 rounded-full", _ctx.currentSlide === i
                ? 'w-6 h-2 bg-primary-500'
                : 'w-2 h-2 bg-neutral-300 hover:bg-neutral-400'])
              }, null, 10, _hoisted_39))
            }), 128))
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "absolute -z-10 -bottom-8 -right-8 w-64 h-64 bg-primary-100 rounded-full blur-3xl opacity-60" }, null, -1)),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "absolute -z-10 -top-8 -left-8 w-48 h-48 bg-accent-50 rounded-full blur-3xl opacity-60" }, null, -1))
        ])
      ])
    ])
  ]))
}